<info-view
  *ngIf="mode === 'view'"
  [data]="data$ | async"
  [loading]="loading"
  (startEditing)="onStartEditing()"
  (deleted)="onDelete($event)"
></info-view>

<info-edit
  *ngIf="mode === 'create' || mode === 'edit'"
  [data]="data$ | async"
  [loading]="loading"
  (saved)="onSaveData($event)"
  (canceled)="onCancel()"
></info-edit>
